module.exports = __webpack_public_path__ + "img/mobile/Menus-paytable/A_K_Q@2x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/Menus-paytable/A_K_Q@2x.png
// module id = 702
// module chunks = 0